import { useQuery } from '@tanstack/react-query';
import Api, { withAcl } from 'hooks/Api';
import { useProvider } from 'utils/providers/Provider';
import { useProfile } from 'utils/helpers';
import { Profile } from 'utils/types';

import c from '../utils/constants';
import profile from '../transformers/profileTransformer';

export default function useGetProfile() {
  const { updateProfile } = useProfile();
  const { state } = useProvider();
  const args = state;

  return useQuery<Profile, Error>({
    queryKey: [c.PROFILE],
    queryFn: async () => {
      const api = new Api(args);

      const data = await api.get(
        await withAcl({
          admin: {
            url: 'api/v1/admins/profile',
            transformer: profile,
          },
          account: {
            url: 'api/v1/accounts/profile',
            transformer: profile,
          },
        }),
      );

      return data?.data;
    },
    // stale time of 30 mins
    // staleTime: 1000 * 60 * 30,
    // cacheTime: 1000 * 60 * 35,
    onSuccess: (profileData) => {
      updateProfile({ profile: profileData });
    },
    // only fetch if profile and token exists
    enabled: state?.isAuthenticated,
  });
}
